import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import Hamburger from 'react-hamburgers';

import cx from 'classnames';

import {
    faEllipsisV,

} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
    Button
} from 'reactstrap';

import {
    setEnableMobileMenuViewRevise,
    setEnableMobileMenuSmallViewRevise,
} from '../../Reducers/ThemeOptions';

class AppMobileMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
            mobile: false,
            activeSecondaryMenuMobile: false
        };

    }

    toggleMobileSidebar = () => {
        let { enableMobileMenuView, setEnableMobileMenuViewRevise } = this.props;
        setEnableMobileMenuViewRevise(!enableMobileMenuView);
    }

    toggleMobileSmall = () => {
        let { enableMobileMenuSmall, setEnableMobileMenuSmallViewRevise } = this.props;
        setEnableMobileMenuSmallViewRevise(!enableMobileMenuSmall);
    }

    state = {
        openLeft: false,
        openRight: false,
        relativeWidth: false,
        width: 280,
        noTouchOpen: false,
        noTouchClose: false,
    };

    render() {
        let { enableMobileMenuView } = this.props;

        return (
            <Fragment>

                <div className="app-header__mobile-menu">
                    <div onClick={this.toggleMobileSidebar}>
                        <Hamburger
                            active={enableMobileMenuView}
                            type="elastic"
                            onClick={() => this.setState({ activeMobile: !this.state.activeMobile })}
                        />
                    </div>
                </div>
                <div className="app-header__menu">
                    <span onClick={this.toggleMobileSmall}>
                        <Button size="sm"
                            className={cx("btn-icon btn-icon-only", { active: this.state.activeSecondaryMenuMobile })}
                            color="primary"
                            onClick={() => this.setState({ activeSecondaryMenuMobile: !this.state.activeSecondaryMenuMobile })}
                        >
                            <div className="btn-icon-wrapper"><FontAwesomeIcon icon={faEllipsisV} /></div>
                        </Button>
                    </span>
                </div>
            </Fragment>
        )
    }
}


const mapStateToProps = state => ({
    closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
    enableMobileMenuView: state.ThemeOptions.enableMobileMenuView,
    enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = dispatch => ({

    setEnableMobileMenuViewRevise: enable => dispatch(setEnableMobileMenuViewRevise(enable)),
    setEnableMobileMenuSmallViewRevise: enable => dispatch(setEnableMobileMenuSmallViewRevise(enable)),

});

export default connect(mapStateToProps, mapDispatchToProps)(AppMobileMenu);